<p class="text-title-lgx-bold">Términos y condiciones</p>
<p class="text-info-bold-xs mt-xxs mb-xlg">PARA ACEPTAR LOS TÉRMINOS Y CONDICIONES DA CLIC EN CONTINUAR</p>

<div class="privacy-politics">
  <div class="scroll-content text-black">
    <p class="privacy-text" [innerHTML]="(clinic$ | async)?.privacyText"></p>
  </div>
</div>
